import React from "react";
import { FormSectionElements, FormSubSections, ProgramContainer } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import validator from 'validator'
import XMLParser from "../../utilities/XMLParser";
import Utils from "../../utilities/Utils";
import { OntarioColumn, OntarioRow } from "../../theme";
import { CheckboxComponent } from "./CheckboxComponent";
import { TextComponent } from "./TextComponent";
import { PhoneComponent } from "./PhoneComponent";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { RichTextComponent } from "./RichTextComponent";
import { ButtonComponent } from "./ButtonComponent";
import { ElementComponent } from "../ElementComponent";
import { getRootComponent } from "../../utilities/ElementUtils";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  roleBasedEditable;
  optionsFieldValue;
  user;
  roleBased;
  ownerEditableOnly;
  UseAsterisks;
  returnIndex

  labelControlArray;

  isEng: boolean;
  callbackValidate?: (errors:any)=>void;
  callbackStepIndex?: (index: number, returnIndex?: number) => void;
  callbackGeneratePdf?: (field: FormSectionElements) => void;
  callbackElement: (programContainer: ProgramContainer)=> void;
}

interface State {


}
export class RowComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

    this.props.field.Touched = false;
    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
  }


  onTextEditChange = (e) => {
    let field = this.props.field;
    let elem = e.originalEvent ? e.originalEvent.target : e.target;
    let val = elem.value;
    field.Value = val;

    FormValidationUtils.validateText(field);

    FormValidationUtils.runJavascript(field);

    this.props.callbackElement(getRootComponent(this.props.field));
  }


  render() {
    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
    if (!field.Visible) return null;
    let fieldHtml = [];

      if (field.subSectionList !== undefined && field.subSectionList != null && field.subSectionList.length > 0) {
        field.subSectionList[0].ListOfFormSectionElements.forEach(p => {
          const title = this.props.isEng ? p.ENUTitle : p.FRATitle;

          let labelControlArray = (
            <label htmlFor={p.LoadBindName} className="ontario-label" >
              {title}<span className="ontario-label__flag"><span className='ontario-label__flag'>{this.props.isEng? p.Optional=="N"? "(required)": "(optional)": p.Optional=="N"? "(obligatoire)": "(facultatif)"}</span>
              </span>
              {p.TooltipENU && (<i role='tooltip' title={p.TooltipENU} className="pi pi-info-circle"></i>)}
            </label>
          )
        fieldHtml.push(
          <ElementComponent
            key={p.LoadBindName + "_" + field.Id + '_ElementComponent_field_' + p.Id}
            isEng={this.props.isEng}
            field={p}
            editable={this.props.editable}
            roleBasedEditable={this.props.roleBasedEditable}
            callbackElement={(container) => {this.props.callbackElement(container);}}
            optionsFieldValue={this.props.optionsFieldValue}
            user={this.props.user}
            roleBased={this.props.roleBased}
            ownerEditableOnly={this.props.ownerEditableOnly}
            UseAsterisks={this.props.UseAsterisks}
            returnIndex={this.props.returnIndex}
          callbackValidate={(errors)=>this.props.callbackValidate(errors)}
          callbackStepIndex={(index,returnIndex)=>this.props.callbackStepIndex(index, returnIndex)}
          callbackGeneratePdf={this.props.callbackGeneratePdf}
          />
        );

        })
      }


    return <div style={{ display: 'flex', width: '100%', gap: `${field.Gap}px`, alignItems: 'flex-end' }}>
      {fieldHtml}

    </div>;
  }

}
